import api from '../connectors/Api'
import Vue from 'vue'

const API = api()

export default {
  namespaced: true,
  state: {
    filters: {},
    filtersData: {
      languages: {},
      countries: {},
      cities: {},
      theOldestAgeOfChannels: 1,
      maxEngagementRate: 100
    },
    items: []
  },
  mutations: {
    setItems (state, list) {
      state.items = list
    },
    setFilter (state, { key, value }) {
      const newFilter = {}
      newFilter[key] = value
      state.filters = { ...state.filters, ...newFilter }
    },
    setFilterData (state, data) {
      state.filtersData = {
        languages: Object.fromEntries(data.languages.map(item => [item, Vue.$languagesList.get()[item]])),
        countries: Object.fromEntries(data.countries.map(item => [item, Vue.$countriesList.get()[item]])),
        cities: Object.fromEntries(data.cities.map(item => [item, item])),
        theOldestAgeOfChannels: parseInt(data.theOldestAgeOfChannels),
        maxEngagementRate: parseFloat(data.maxEngagementRate)
      }
    },
    clearFilters (state) {
      state.filters = {}
    }
  },
  getters: {
    activeFiltersNum (state) {
      let counter = 0
      for (const key in state.filters) {
        if (state.filters[key] !== null && state.filters[key] !== undefined) {
          counter++
        }
      }
      return counter
    },
    filtersTag (state) {
      const filters = {}
      for (const key in state.filters) {
        if (state.filters[key] !== null && state.filters[key] !== undefined) {
          filters[key] = state.filters[key]
        }
      }
      return filters
    },
    filtersForApi (state) {
      const filters = {}
      for (const key in state.filters) {
        if (state.filters[key] !== null && state.filters[key] !== undefined) {
          if (state.filters[key].min || state.filters[key].max) {
            if (state.filters[key].min) {
              filters['min_' + key] = state.filters[key].min
            }
            if (state.filters[key].max) {
              filters['max_' + key] = state.filters[key].max
            }
          } else {
            filters[key] = state.filters[key]
          }
        }
      }
      return filters
    }
  },
  actions: {
    search ({ commit, state, dispatch, getters }) {
      return new Promise((resolve, reject) => {
        dispatch('auth/getAccessToken', null, { root: true }).then((token) => {
          const data = getters.filtersForApi
          API.search(token, data)
            .then((res) => {
              commit('setItems', res.body)
              resolve(state.items)
            })
            .catch((e) => {
              reject(e)
            })
        }).catch((e) => reject(e))
      })
    },
    getFiltersData ({ commit, state, dispatch }) {
      return new Promise((resolve, reject) => {
        dispatch('auth/getAccessToken', null, { root: true }).then((token) => {
          API.getSearchFiltersData(token)
            .then((res) => {
              commit('setFilterData', res.body)
              resolve(res.body)
            })
            .catch((e) => {
              reject(e)
            })
        }).catch((e) => reject(e))
      })
    },
    contactWanted ({ commit, state, dispatch }, data) {
      return new Promise((resolve, reject) => {
        dispatch('auth/getAccessToken', null, { root: true }).then((token) => {
          API.searchContactWanted(token, data)
            .then((res) => {
              resolve(res.body)
            })
            .catch((e) => {
              reject(e)
            })
        }).catch((e) => reject(e))
      })
    }
  }
}
